(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('languageSelection', ['$localStorage', 'AdministrationService', LanguageSelectionFn]);


    /* select box for languages */
    function LanguageSelectionFn($localStorage, AdministrationService) {
        var directive = {
            restrict: 'E',
            scope: {
                languages: '='
            },
            replace: true,
            templateUrl: '/app/global/templates/rf-global-language-selection.template.html',
            link: link
        };

        function link(scope, element) {
            // current language
            scope.currentLanguage = {};

            activate();

            /* do some activation */
            function activate() {
                if (!$localStorage.CurrentLanguage) {
                    // set preferred language (default)
                    scope.languages.forEach(function (lang) {
                        if (lang.isDefault) {
                            // change language
                            changeLanguage(lang);
                        } // if
                    });
                } //if  
                else { changeLanguage($localStorage.CurrentLanguage); }
            }

            // select Language for site
            scope.selectLanguage = function (lang) {
                if (!lang) {
                    return;
                }
                changeLanguage(lang);
            };

            // update language-dependent services
            function changeLanguage(language) {
                if (language === undefined || language === null) { return; }
                // set language for ui
                scope.currentLanguage = language;
                // set language for view
                AdministrationService.setLanguage(language);
            }
        }

        return directive;



    }

})();